<template>
  <v-dialog persistent :value="show" max-width="290">
    <v-card>
      <v-card-title>
        {{ titleText }}
      </v-card-title>
      <v-card-text
        ><p
          class="ma-0 pa-0"
          v-html="$sanitize(descriptionText, { allowedTags: ['a'] })"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <Button
          color="grey"
          plain
          :data-testid="cancelTestID"
          :text="$t('common.button.cancel')"
          @click="$emit('cancel')"
        />
        <Button
          plain
          color="danger"
          :data-testid="confirmTestID"
          :text="confirmationText"
          @click="$emit('continue')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Button from '@/components/UI/Button'
export default {
  name: 'LinkedFindingWarningDialog',

  components: {
    Button,
  },

  props: {
    title: String,
    text: String,
    show: Boolean,
    isLoading: Boolean,
    confirmText: String,
    confirmTestID: {
      type: String,
      default: 'looseFindingLink-button-confirm',
    },
    cancelTestID: { type: String, default: 'looseFindingLink-button-cancel' },
    item: Object,
  },

  computed: {
    titleText() {
      return this.title ?? this.$t('checklist.edit_answer')
    },
    descriptionText() {
      return this.text ?? this.$t('checklist.edit_answer_warning')
    },
    confirmationText() {
      return this.confirmText ?? this.$t('common.button.continue')
    },
  },
}
</script>
